import { Injectable } from '@angular/core';
import { Guid } from 'guid-typescript';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _apiKey?: Guid | null;

  setApiKey(apiKey: Guid | null): void {
    this._apiKey = apiKey;
  }

  getApiKey(): Guid {
    return this._apiKey!;
  }
}
